<!--
  This is the property of FRBNY and cannot be shared or disclosed without consent and strictly prohibited.
  
  Reusable footer component matching FRBNY branding
  Generated by: AI-DLC Workflow
-->
<template>
  <footer class="frbny-footer">
    <div class="footer-content">
      <div class="footer-links">
        <a href="https://www.newyorkfed.org/privacy/termsofuse" target="_blank" rel="noopener noreferrer" class="footer-link">Terms of Use</a>
        <span class="separator">|</span>
        <a href="https://www.newyorkfed.org/privacy" target="_blank" rel="noopener noreferrer" class="footer-link">Privacy</a>
      </div>
            <div class="footer-seal"></div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// No props or logic needed for static footer
</script>

<style scoped>
.frbny-footer {
  background-color: #001F33;
  color: #ffffff;
  padding: 1.5rem 0.75rem;
  box-shadow: none;
  border-top: 1px solid #DDDBD7;
  position: relative;
  min-height: 166px;
  overflow: hidden;
}

.footer-content {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  height: 100%;
  position: relative;
}

.footer-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.5rem;
  position: relative;
  z-index: 1;
}

.footer-link {
  font-family: 'Roboto Condensed', sans-serif;
  color: #ffffff;
  text-decoration: none;
  font-size: 0.8125rem;
  transition: opacity 0.2s ease;
  letter-spacing: 0.24px;
}

.footer-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.separator {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8125rem;
}

.footer-seal {
  position: absolute;
  right: -10%;
  top: 370%;
  transform: translateY(-50%);
  width: 100%;
  height: 900%;
  background-image: url('@/assets/styles/images/ny-fed-seal.png');
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
  opacity: 0.6;
  pointer-events: none;
  filter: brightness(1.3);
  mix-blend-mode: lighten;
}

/* Responsive design */

/* Mobile Extra Small */
@media (max-width: 375px) {
  .frbny-footer {
    padding: 1.25rem 0.75rem;
    min-height: 150px;
  }

  .footer-content {
    flex-direction: column;
    gap: 1rem;
  }

  .footer-link {
    font-size: 0.75rem;
  }

    .footer-seal {
    width: 90%;
    height: 120%;
    right: -15%;
    opacity: 0.5;
    filter: brightness(1.2);
  }
}

/* Tablet and Mobile */
@media (max-width: 768px) {
  .frbny-footer {
    padding: 1.5rem 20px;
  }

  .footer-links {
    justify-content: flex-start;
  }
}

/* Tablet */
@media (min-width: 769px) and (max-width: 1023px) {
  .frbny-footer {
    padding: 1.75rem 0.75rem;
    min-height: 180px;
  }

  .footer-links {
    justify-content: flex-start;
  }

    .footer-seal {
    width: 95%;
    height: 130%;
    right: -12%;
    opacity: 0.55;
    filter: brightness(1.25);
  }
}

/* Extra small mobile devices */
@media (max-width: 480px) {
  .frbny-footer {
    padding: 1.25rem 16px;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .footer-links {
    justify-content: flex-start;
    gap: 0.75rem;
  }

  .footer-link {
    font-size: 0.875rem;
  }

  .separator {
    font-size: 0.875rem;
  }

  .footer-seal {
    width: 100%;
    height: 900%;
    filter: brightness(1.3);
  }
}
</style>
